module.exports = __webpack_public_path__ + "assets/img/panda1.4c4c20e9.png";